import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../services/service.index';
import { RolesService } from '../services/roles/roles.service';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-loginbankaool',
  templateUrl: './loginbankaool.component.html',
  styleUrls: ['./loginbankaool.component.css']
})
export class LoginBankaoolComponent implements OnInit {
  showPassword = false;
  recuperacont = false;
  email = '';
  password = '';

  constructor(
    public router: Router,
    private usuarioservice: UsuarioService,
    private rolesService: RolesService
  ) {}

  ngOnInit() {
    document.title = 'Bankaool - Crédito Nómina';
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (favicon) { favicon.href = './assets/img/bankaool/bankaool-favicon.ico'; }

    if (localStorage.length > 0 && localStorage.getItem('quiensoy') === 'bankaool') {
      this.rolesService.getRol(localStorage.getItem('rid')).subscribe(resp => {
        if (resp[0].name === 'SuperAdmin') {
          this.router.navigate(['/dashboardAdmin']);
        } else if (resp[0].name === 'Clientes') {
          this.usuarioservice.getCustomerxidu(localStorage.getItem('uid')).subscribe(r => {
            if (r.length > 0) {
              this.router.navigate(['/maincliente']);
            } else {
              this.router.navigate(['/registroemp']);
            }
          });
        } else {
          this.router.navigate(['/panelcontrol/aprobarCreditos/mesaControl']);
        }
      }, err => {
        console.log('error', err);
      });
    }
  }

  login() {
    swal2.showLoading();
    this.usuarioservice.login(this.email, this.password).subscribe(resp => {
      if (resp.data.attributes.status !== 'AC') {
        swal2.fire('El usuario no se encuentra activo', '', 'error');
      } else {
        localStorage.setItem('uid', resp.data.attributes.id);
        localStorage.setItem('tkn', resp.data.token);
        localStorage.setItem('emailuser', resp.data.attributes.email);
        localStorage.setItem('nombreuser', resp.data.attributes.name);
        localStorage.setItem('expiratoken', resp.data.expires_at);
        localStorage.setItem('firmante', resp.data.attributes.company_signatory);
        localStorage.setItem('quiensoy', 'bankaool');
        if (resp.data.attributes.role_id != null) {
          localStorage.setItem('rid', resp.data.attributes.role_id);
          window.location.reload();
        } else {
          swal2.fire('Datos incompletos', 'Comuníquese con el administrador', 'info');
        }
      }
    }, err => {
      console.clear();
      swal2.fire('Error al acceder', 'Revise su información', 'error');
    });
  }

  recuperarcont() {
    this.recuperacont = !this.recuperacont;
  }

  enviacrecuperacion() {
    const email = (document.getElementById('emailrecbankaool') as HTMLInputElement).value;
    this.usuarioservice.getResetPaswword(email).subscribe(resp => {
      this.recuperacont = !this.recuperacont;
      swal2.fire('El correo de recuperación fue enviado a:', email, 'success');
    }, err => {
      swal2.fire('Error', err.error.errors[0], 'error');
    });
  }
}
